export default __webpack_public_path__ + "swim-safety-associations.svg";